module.exports = __webpack_public_path__ + "static/media/profile.57886b11.jpg";